<template>
  <v-container>
    <p class="headline" align="center" style="margin-bottom:50px;">
      Invite influencers for campaign:
      <strong>{{campaign.campaignName}}</strong>
    </p>
    
   
    
    <v-row >
      <!-- <v-col cols="12" sm="12" lg="6" md="6">
        <v-card>
          <v-card-title>Campaign Details</v-card-title>
          <v-card-text>
            <p class="ma-0 subtitle-1">Budget: {{campaign.campaignBudget | currency}}</p>
            <p class="ma-0 subtitle-1">Outreach: {{campaign.campaignOutreach | thousandSeprator}}</p>
            <p
              class="ma-0 subtitle-1"
            >Engagement: {{campaign.campaignEngagement | thousandSeprator}}</p>
          </v-card-text>
        </v-card>
      </v-col> -->
      <!-- <v-col cols="12" sm="12" lg="4" md="5">
        <v-card outlined>
          <v-card-title>Client Details</v-card-title>
          <v-card-text>            
            <p class="ma-0 subtitle-1"><strong>Client:</strong> {{client.clientName}}</p>
            <p class="ma-0 subtitle-1"><strong>Email:</strong> {{client.clientEmail}}</p>
            <p class="ma-0 subtitle-1" v-show="client.clientPhoneNumber"><strong>Phone:</strong> {{client.clientPhoneNumber}}</p>
            <p class="ma-0 subtitle-1" v-show="client.clientWebsite">
              <strong>Website:</strong>
              <a target="_blank" :href="client.clientWebsite">{{client.clientWebsite}}</a>
            </p>
            <p class="ma-0 subtitle-1"><strong>Address:</strong> {{client.clientAddress}}</p>
          </v-card-text>
        </v-card>
      </v-col> -->
      <v-col>
        <div>
          <div class="client_deteial_title">Client Details</div>
          <div>
            <p class="ma-0 subtitle-1"><strong>Client Name:</strong> {{client.clientName}}</p>
            <p class="ma-0 subtitle-1"><strong>Email:</strong> {{client.clientEmail}}</p>
            <p class="ma-0 subtitle-1" v-show="client.clientPhoneNumber"><strong>Phone:</strong> {{client.clientPhoneNumber}}</p>
            <p class="ma-0 subtitle-1" v-show="client.clientWebsite">
              <strong>Website:</strong>
              <a target="_blank" :href="client.clientWebsite">{{client.clientWebsite}}</a>
            </p>
            <!-- <p class="ma-0 subtitle-1"><strong>Address:</strong> {{client.clientAddress}}</p> -->
          </div>
        </div>
      </v-col>
    </v-row>
    <hr/>
    <v-row>
      <v-col cols="12" sm="12" lg="3" md="3">
        <v-hover v-slot:default="{ hover }">
          <v-card
            color="#78909C"
            dark
            :elevation="hover ? 12 : 2"
            :class="{ 'on-hover': hover }"
          >
            <v-card-title class="headline">Contents</v-card-title>
            <v-card-subtitle>
              <p
                class="pa-0 ma-0 custom-font"
              >Target : {{ campaign.min_content }} to {{ campaign.max_content }}</p>
              <p class="pa-0 ma-0 custom-font">Current Total: {{measurement.total}}</p>
              <p class="pa-0 ma-0 custom-font">Invited Total: {{measurement.invitedTotal}}</p>
              <p class="pa-0 ma-0 custom-font">Not Invited Total: {{measurement.notInvitedTotal}}</p>              
              <p class="pa-0 ma-0 custom-font">Percentage: {{measurement.totalPercentage}} %</p>
            </v-card-subtitle>
          </v-card>
        </v-hover>
      </v-col> 
      <v-col cols="12" sm="12" lg="3" md="3">
        <v-hover v-slot:default="{ hover }">
          <v-card
            color="#00838F"
            dark
            :elevation="hover ? 12 : 2"
            :class="{ 'on-hover': hover }"
          >
            <v-card-title class="headline">Outreach</v-card-title>
            <v-card-subtitle>
              <p
                class="pa-0 ma-0 custom-font"
              >Target : {{ campaign.outreach | thousandSeprator}}</p>
              <p
                class="pa-0 ma-0 custom-font"
              >Current Total: {{measurement.outreach | thousandSeprator}}</p>
              <p class="pa-0 ma-0 custom-font">Invited Total: {{measurement.invitedOutreach | thousandSeprator}}</p>
              <p class="pa-0 ma-0 custom-font">Not Invited Total: {{measurement.notInvitedOutreach | thousandSeprator}}</p>
              <p class="pa-0 ma-0 custom-font">Percentage: {{measurement.outreachPercentage}}%</p>
            </v-card-subtitle>
          </v-card>
        </v-hover>
      </v-col>
      <v-col cols="12" sm="12" lg="3" md="3">
        <v-hover v-slot:default="{ hover }">
          <v-card
            color="#00C853"
            dark
            :elevation="hover ? 12 : 2"
            :class="{ 'on-hover': hover }"
          >
            <v-card-title class="headline">Engagement</v-card-title>
            <v-card-subtitle>
              <p
                class="pa-0 ma-0 custom-font"
              >Target : {{ campaign.engagement | thousandSeprator}}</p>
              <p
                class="pa-0 ma-0 custom-font"
              >Current Total: {{measurement.engagement | thousandSeprator}}</p>
              <p class="pa-0 ma-0 custom-font">Invited Total: {{measurement.invitedEngagement | thousandSeprator}}</p>
              <p class="pa-0 ma-0 custom-font">Not Invited Total: {{measurement.notInvitedEngagement | thousandSeprator}}</p>
              <p class="pa-0 ma-0 custom-font">Percentage: {{measurement.engagementPercentage}}%</p>
            </v-card-subtitle>
          </v-card>
        </v-hover>
      </v-col>
      <v-col cols="12" sm="12" lg="3" md="3">
        <v-hover v-slot:default="{ hover }">
          <v-card
            color="#0091EA"
            dark
            :elevation="hover ? 12 : 2"
            :class="{ 'on-hover': hover }"
          >
            <v-card-title class="headline">Budget</v-card-title>
            <v-card-subtitle>
              <p class="pa-0 ma-0 custom-font">Target : {{ budget | currency }}</p>
              <p class="pa-0 ma-0 custom-font">COGS: {{measurement.budget | currency}}</p>
              <p class="pa-0 ma-0 custom-font">Invited COGS: {{measurement.invitedBudget | currency}}</p>
              <p class="pa-0 ma-0 custom-font">Not Invited COGS: {{measurement.notInvitedBudget | currency}}</p>
              <p
                class="pa-0 ma-0 custom-font"
              >Percentage: {{measurement.cogsPercentage}}%</p>
            </v-card-subtitle>
          </v-card>
        </v-hover>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" sm="12" md="12" lg="12">
        <v-btn color="success" class="mb-2" :disabled="disableSaveEdit" @click="saveEditingData">Save Changes</v-btn>
        <v-btn color="warning" class="mb-2" v-if="!disableSaveEdit" @click="cancelEdit">Cancel</v-btn>
      </v-col>
    </v-row>
    <v-row>
      <v-col>        
        <v-data-table
          :headers="headers"
          :items="influencers"
          sort-by="calories"
          show-select
          @toggle-select-all="selectAllInfluencers"
          :single-select="false"
          class="elevation-1"
        >
          <template v-slot:top>
            <v-toolbar flat color="white">
              <v-toolbar-title>Influencers</v-toolbar-title>
              <v-divider class="mx-4" inset vertical></v-divider>
              <v-spacer></v-spacer>
              <v-dialog
                v-model="dialog"
                max-width="500px"
                content-class="ims-standard-dialog"
              >
                <v-card class="ims-modal-card">
                  <v-card-title class="edit-influencer-title">
                    <span class="headline">Edit Influencer{{ formTitle? ` - ${formTitle}` : '' }}</span>
                    <v-spacer></v-spacer>
                    <v-btn
                      icon
                      color="secondary"
                      aria-label="Close"
                      title="Close"
                      @click="close"
                    >
                      <v-icon>mdi-close</v-icon>
                    </v-btn>
                  </v-card-title>

                  <v-card-text>
                    <v-container>
                      <v-row>
                         <v-col cols="12" sm="12" md="12">
                          <v-text-field
                            v-model="editedItem.email"
                            label="Email"
                            color="secondary"
                          ></v-text-field>
                        </v-col>
                      </v-row>
                      <v-row>                       
                        <v-col cols="12" sm="6" md="4">
                          <v-text-field
                            type="number"
                            min="0"
                            v-model="editedItem.no_of_posts"
                            label="IG Post deliverables"
                            color="secondary"
                          ></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="6" md="4">
                          <v-text-field
                            type="number"
                            min="0"
                            v-model="editedItem.no_of_carousels"
                            label="IG Carousel deliverables"
                            color="secondary"
                          ></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="6" md="4">
                          <v-text-field
                            type="number"
                            min="0"
                            v-model="editedItem.no_of_stories"
                            label="IG Story deliverables"
                            color="secondary"
                          ></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="6" md="4">
                          <v-text-field
                            type="number"
                            min="0"
                            v-model="editedItem.no_of_video"
                            label="IG Video deliverables"
                            color="secondary"
                          ></v-text-field>                          
                        </v-col>
                        <v-col cols="12" sm="6" md="4">
                          <v-text-field
                            type="number"
                            min="0"
                            v-model="editedItem.no_of_igTv"
                            label="IG TV deliverables"
                            color="secondary"
                          ></v-text-field>                          
                        </v-col>
                      </v-row>
                    </v-container>
                  </v-card-text>

                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="secondary" text @click="close">Cancel</v-btn>
                    <v-btn color="secondary" text @click="save">Save</v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>
            </v-toolbar>
          </template>
          <!-- <template v-slot:item.actions="{ item }">
            <v-icon small class="mr-2" @click="editItem(item)">mdi-pencil</v-icon>
          </template>-->
          <!-- <template v-slot:no-data>
            <v-btn color="secondary" @click="initialize">Reset</v-btn>
          </template>-->
          <template v-slot:body="{ items }">
            <tbody>
              <tr v-for="item in items" :key="item.name">
                <td>
                  <v-checkbox
                    :value="item.id"
                    v-model="selectedInfluencers"
                    :disabled="!isValidPairing(item)"
                  ></v-checkbox>
                </td>
                <td>
                  <a
                    :href="'https://www.tiktok.com/@' + item.instagramHandle"
                    target="_blank"
                    v-if="item.platform === 'tiktok'"
                  ><img src="/static/img/tiktok-32.png" width="20px" /> @{{item.instagramHandle}}</a>
                  <a
                    target="_blank"
                    :href="'https://instagram.com/' + item.instagramHandle"
                    v-else
                  ><v-icon small>mdi-instagram</v-icon> @{{item.instagramHandle}}</a>
                   <v-tooltip v-if="!item.isLoading && item.influencerID" bottom>
                    <template v-slot:activator="{ on }">
                      <v-icon @click="true" color="green" v-on="on">done</v-icon>
                    </template>
                    <span>Registered on IMS</span>
                  </v-tooltip>
                  <v-tooltip v-if=" !item.isLoading && !item.influencerID" bottom>
                    <template v-slot:activator="{ on }">
                      <v-icon @click="true" color="red" v-on="on">cancel</v-icon>
                    </template>
                    <span>Not in IMS</span>
                  </v-tooltip>
                </td>                
                <td>
                  <div class="item-edit" @click="openEditItem(item, 'email')" v-if="item.emailEdit === false">
                    <td class="text-xs-left" style="min-width:75px">{{item.email}}</td>
                  </div>
                  <div v-else>
                    <v-text-field
                      class="mt-3"
                      v-model="item.email"
                      outlined
                      color="secondary"
                      v-on="on"
                      style="width:290px;"
                    ></v-text-field>
                  </div>
                  <!-- {{item.email}} -->
                </td>
                <td>{{item.payout | currency}}</td>
                <td>
                  <p class="ma-0 body-2" v-if="item.no_of_posts">
                    <span>{{item.no_of_posts > 0 ? item.no_of_posts : '' }} {{ item.no_of_posts > 0 ? item.no_of_posts > 1 ? 'Posts' : 'Post' : '' }}</span>
                  </p>
                  <p class="ma-0 body-2" v-if="item.no_of_carousels">
                    <span>{{item.no_of_carousels > 0 ? item.no_of_carousels : '' }} {{item.no_of_carousels > 0 ? item.no_of_carousels > 1 ? 'Carousels' : 'Carousels' : ''}}</span>
                  </p>
                  <p class="ma-0 body-2" v-if="item.no_of_stories">
                    <span>{{item.no_of_stories > 0 ? item.no_of_stories : '' }}  {{item.no_of_stories > 0 ? (item.no_of_stories > 1 ? 'Stories' : 'Story') : ''}} </span>
                  </p>
                  <!-- <p class="ma-0 body-2" v-if="item.no_of_carousel">
                    <span>{{item.no_of_carousel}} {{item.no_of_carousel > 1 ? 'Carousels' : 'Carousel'}}</span>
                  </p> -->
                  <p class="ma-0 body-2" v-if="item.no_of_video">
                    <span>{{item.no_of_video > 0 ? item.no_of_video : ''}} {{item.no_of_video > 0 ? item.no_of_video > 1 ? 'Videos' : 'Video' : ''}}</span>
                  </p>
                  <p class="ma-0 body-2" v-if="item.no_of_igTv">
                    <span>{{item.no_of_igTv > 0 ? item.no_of_igTv : '' }} {{item.no_of_igTv > 0 ? item.no_of_igTv > 1 ? 'TVs' : 'TV' : ''}}</span>
                  </p>
                </td>
                <td>
                  <pairing-status :status="item.pairingStatus"></pairing-status>
                </td>
                <td>
                  <v-btn fab small color="secondary" @click="editItem(item)">
                    <v-icon small>mdi-pencil</v-icon>
                  </v-btn>
                  <v-btn
                    fab
                    small
                    color="secondary"
                    @click="preview(item, selectedTemplate.templateHTML)"
                  >
                    <v-icon small>mdi-file-find</v-icon>
                  </v-btn>
                  <!-- <v-tooltip top v-if="!item.influencerID">
                    <template v-slot:activator="{ on }">
                      <v-btn
                        fab
                        dark
                        v-on="on"
                        small
                        color="purple"
                        @click="sendRegisterLink(item)"
                      >
                        <v-icon small>mdi-send-outline</v-icon>
                      </v-btn>
                    </template>
                    <span>Send private link to register on IMS</span>
                  </v-tooltip> -->
                </td>
              </tr>
            </tbody>
          </template>
        </v-data-table>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <v-btn
            class="mb-2"
            color="secondary"            
            @click.stop="emailDialog = true"
          >          
          Invite with Email
          <v-icon 
          dark
          right>
            mdi-email-plus
          </v-icon>
        </v-btn>
        <v-btn
          class="mb-2"
          color="warning"
          :disabled="!selectedInfluencers || selectedInfluencers.length === 0"
          @click="updateInvitedStatus(selectedInfluencers)"
        >Invite ({{selectedInfluencers.length}})</v-btn>
      </v-col>
    </v-row>

    <!-- Email Invitation dialog -->
    <v-dialog v-model="emailDialog" max-width="700" persistent>  
      <!-- <v-toolbar dark flat color="primary">
        <v-toolbar-title>Email template creation</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn icon dark @click="emailDialog = false">
            <v-icon>mdi-close</v-icon>
        </v-btn>        
      </v-toolbar>     -->
      <v-card>
        <v-card-title style="margin-bottom:10px;">
          Email template creation
          <v-spacer></v-spacer>
          <v-btn icon @click="emailDialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
          <v-card-text>
            <v-autocomplete
              class="mb-2"
              :items="templates"
              item-text="name"
              v-model="selectedTemplate"
              hide-details
              dense
              filled
              return-object
              label="Select Template"
            ></v-autocomplete>
            <v-autocomplete
              class="mb-2"
              :items="fromEmail"
              item-text="name"
              v-model="selectedFromEmail"
              hide-details
              dense
              filled
              return-object
              label="From:"
            ></v-autocomplete>
            <v-text-field
              lass="mb-2"
              hide-details
              label="Subject"
              single-line
              filled
              v-model="selectedTemplate.subject"
              style="margin:10px 0px 10px 0px"
            ></v-text-field>
            <v-text-field
              lass="mb-2"              
              label="Campaign Invite URL"              
              filled
              v-model="inviteUrl"
              readonly
              style="margin:10px 0px 10px 0px"
              @focus="$event.target.select()"
            ></v-text-field>
            
            <!-- <wysiwyg v-model="selectedTemplate.templateHTML" /> -->
            <vue-editor v-model="selectedTemplate.templateHTML"></vue-editor>
            <p class="title" v-if="keywords && keywords.length > 0 ">Map values</p>
            <v-row align="center" justify="center" v-for="keyword of keywords" :key="keyword">
              <v-col cols="5" align="end" justify="end">
                <!-- <v-chip class="ma-2">{{keyword}}</v-chip> -->
                <v-text-field label="Source" filled disabled hide-details :value="keyword"></v-text-field>
              </v-col>
              <v-col cols="2" align="center" justify="center">
                <v-icon color="primary">mdi-arrow-left-right</v-icon>
              </v-col>
              <v-col cols="5" align="center" justify="center">
                <v-autocomplete
                  :items="fields"
                  class="mb-2"
                  hide-details
                  @change="mapValue($event, keyword)"
                  :value="keywordsMap.get(keyword)"
                  dense
                  filled
                  label="Target"
                ></v-autocomplete>
              </v-col>
            </v-row>
            <v-row style="margin-top:10px;">
              <v-col>
                <v-btn
                  text
                  :disabled="!selectedTemplate._id"
                  @click="saveTemplateChanges(selectedTemplate._id)"
                >Save</v-btn>
                <v-btn text @click="saveNewTemplate">Save As</v-btn>
              </v-col>
            </v-row>
          </v-card-text>
        <v-card-actions>          
          <v-btn
          class="mb-2"
          color="secondary"
          :disabled="!selectedInfluencers || selectedInfluencers.length === 0"
          @click="sendBulkInvitation(selectedInfluencers, selectedTemplate._id)"
        >Send invite ({{selectedInfluencers.length}})</v-btn>
        </v-card-actions>
      </v-card>
      <!-- <classic-editor></classic-editor> -->
      <div id="sweetAlertContainer" style="width:100%;height:auto;"></div>
    </v-dialog>
    <!-- Email Invitation dialog -->
    <!-- Preview dialog -->
    <v-dialog v-model="previewDialog" width="600px">
      <v-card>
        <v-card-title>
          <span class="headline">Preview content</span>
        </v-card-title>
        <v-card-text v-html="previewText"></v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="green darken-1" text @click="previewDialog = false">Close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- Preview dialog -->
    <!-- Toast -->
    <k-toast :variant="toast.variant" :header="toast.header" :content="toast.content"></k-toast>
    <!-- Toast -->
    <!-- Invitation progress -->
    <v-dialog v-model="sendingInvitationDialog" width="400px">
      <v-card>
        <v-card-title>
          <span class="headline" v-if="isSending">In progress...</span>
          <span class="headline" v-if="!isSending">Finished</span>
        </v-card-title>
        <v-card-text>
          <v-progress-linear v-if="isSending" height="15" indeterminate color="yellow darken-2"></v-progress-linear>
          <v-list disabled>
            <v-list-item-group color="primary">
              <v-list-item v-for="(item, i) in sendings" :key="i">
                <v-list-item-icon>                  
                  <v-icon v-if="item.isSuccess" color="success">mdi-check</v-icon>
                  <v-icon v-if="!item.isSuccess" color="red">mdi-cancel</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title>@{{item.instagramHandle}}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-list-item-group>
          </v-list>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="green darken-1"
            :disabled="isSending"
            text
            @click="sendingInvitationDialog = false"
          >Done</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- Invitation progress -->
  </v-container>
</template>
<style scoped>
  .client_deteial_title {
    font-size: 18px;
    font-weight: 500;
    margin-bottom:20px;
  }

  .client_deteial_header {
    font-size: 12px;
    font-weight: 300;
  }
</style>

<script>
import campaignAPIs from '../campaignAPIs';
import userAPIs from '../../User/userAPIs';
import clientAPIs from '../../Client/clientAPIs';
import campaignConfig from '../config';
import pairingAPIs from '../../Pairing/pairingAPIs';
import utils from '../../../../utils';
import config from '@/config';
import { VueEditor } from 'vue2-editor';
import KToast from '../../../scoped/custom/KToast';
import EmailTemplateAPIs from '../EmailTemplateAPIs';
import PairingStatus from '../../../scoped/campaign/PairingStatus';
import Mustache from 'mustache';
import { mapGetters } from 'vuex'
export default {
  name: 'campaign-invite',
  components: {
    VueEditor,
    KToast,
    PairingStatus
  },
  data() {
    return {
      dialog: false,
      emailDialog: false,
      campaign: {},
      keywordsMap: new Map(),
      keywords: [],
      client: {},
      selectedInfluencers: [],
      templates: [],
      selectedFromEmail: [],
      fromEmail: [],
      templateHTML: '',
      // Preview settings
      previewDialog: false,
      previewText: null,
      // Sending invitation
      sendingInvitationDialog: false,
      isSending: false,
      sendings: [], // To show the progress of sending invitation
      selectedTemplate: {
        id: null,
        subject: null,
        name: null,
        templateHTML: null
      },
      inviteUrl: '',
      toast: {
        variant: '',
        content: '',
        header: ''
      },
      fields: [],
      headers: [
        {
          text: 'Instagram',
          align: 'start',
          sortable: false,
          value: 'instagramHandle'
        },
        { text: 'Email', value: 'email' },
        { text: 'Payout', value: 'payout' },
        { text: 'Deliverables' },
        { text: 'Status', value: 'status' },
        { text: 'Actions', value: 'actions', sortable: false }
      ],
      influencers: [],
      editedIndex: -1,
      editedItem: {
        email: '',
        no_of_posts: 0,
        no_of_stories: 0,
        no_of_carousels: 0,
        no_of_video: 0,
        no_of_igTv: 0,
        id: null
      },
      defaultItem: {
        email: '',
        no_of_posts: 0,
        no_of_stories: 0,
        no_of_carousels: 0,
        no_of_video: 0,
        no_of_igTv: 0,
        id: null
      },
      measurement: {
        total: 0,
        outreach: 0,
        engagement: 0,
        budget: 0,
        outreachPercentage: 0,
        engagementPercentage: 0,
        cogsPercentage: 0,
        invitedTotal: 0,
        invitedOutreach: 0,
        invitedEngagement: 0,
        invitedBudget: 0,
        notInvitedTotal: 0,
        notInvitedOutreach: 0,
        notInvitedEngagement: 0,
        notInvitedBudget: 0
      },
      disableSaveEdit: true
    };
  },
  computed: {
    ...mapGetters('pairing', {
      pairingStatus: 'status'
    }),
    statusINVITED() {
      // return campaignConfig.pairingStatus.INVITED;
      return this.pairingStatus.INVITED;
    },
    budget: function() {
      return Math.floor(this.campaign.budget * 0.3);
    }
  },
  watch: {
    'selectedTemplate.templateHTML'(value) {
      this.templateHTML = value;
      this.processKeywords(value);
    },
    dialog(val) {
      val || this.close();
    }
  },
  created() {
    const campaignID = this.$route.params.campaignID;
    if (!campaignID) {
      this.$swal({
        type: 'error',
        text: 'Campaign ID is invalid'
      });
    }
    this.getCampaignDetails(campaignID);
    this.getAllEmailTemplates();
    this.getCampaignUsers(campaignID);
    this.inviteUrl = `${window.location.protocol}//${window.location.host}/campaigns/${campaignID}/invitation`;
  },
  methods: {
    async saveNewTemplate() {
      try {
        if (!this.selectedTemplate || !this.selectedTemplate.templateHTML || !this.selectedTemplate.subject) {
          throw new Error('Please enter the template content and subject');
        }
        const { value: name } = await this.$swal({
          title: 'Enter template name',
          input: 'text',
          showCancelButton: true,
          inputValue: 'Template-' + new Date().getMilliseconds(), // Default name
          confirmButtonText: 'Confirm',
          // showLoaderOnConfirm: true,
          target: document.getElementById('sweetAlertContainer'),
          inputValidator: value => {
            if (!value) {
              return 'Please enter a name';
            }
          }
        });
        if (!name) return;
        const data = {
          templateHTML: this.selectedTemplate.templateHTML,
          name,
          subject: this.selectedTemplate.subject
        };
        const createdTemplate = await EmailTemplateAPIs.createEmailTemplate(data);
        this.makeToast({
          content: 'Template Created',
          header: 'Success!',
          variant: 'success'
        });
        this.templates.push(createdTemplate);
        this.selectedTemplate = Object.assign({}, createdTemplate);
      } catch (error) {
        const message = error && error.message ? error.message : 'Could not create template';
        this.$swal({
          type: 'error',
          text: message
        });
      }
    },
    selectAllInfluencers($event) {
      if (!$event.value) {
        this.selectedInfluencers = [];
        return;
      }
      const influencers = Object.assign([], this.influencers);
      const qualifiedInfluencers = influencers.filter(e => this.isValidPairing(e) && e.pairingStatus < this.statusINVITED.value).map(e => e.id);
      this.selectedInfluencers = Object.assign([], qualifiedInfluencers);
    },
    makeToast(toast) {
      this.toast = toast;
      this.$bvToast.show('kobe-toast');
    },
    processKeywords(text) {
      const pattern = config.regexPattern.search_value;
      let m;
      let keywords = new Map();
      // Find all the replaceable keyword in template
      while ((m = pattern.exec(text)) !== null) {
        // This is necessary to avoid infinite loops with zero-width matches
        if (m.index === pattern.lastIndex) {
          pattern.lastIndex++;
        }

        // Add keyword to the map
        m.forEach((match, groupIndex) => {
          if (!keywords.has(match)) {
            keywords.set(match, 1);
          }
        });
      }
      // Merge with the existing keyword and remove the keywords which does not represent in the template
      const mergedMap = new Map([...keywords, ...this.keywordsMap]);
      for (const key of mergedMap.keys()) {
        if (!keywords.has(key)) {
          mergedMap.delete(key);
        }
      }
      this.keywords = Array.from(mergedMap.keys());
      this.keywordsMap = Object.assign(new Map(), mergedMap);
    },
    mapValue(target, keyword) {
      // Save the map value
      this.keywordsMap.set(keyword, target);
      let html = this.selectedTemplate.templateHTML || '';
      // Replace the keyword with the real keyword from pairing
      html = html.replace(keyword, `{{${target}}}`);
      // Update template
      this.selectedTemplate.templateHTML = html;
    },

    async saveTemplateChanges(templateId) {
      try {
        if (!templateId) return;
        const data = {
          templateHTML: this.selectedTemplate.templateHTML,
          name: this.selectedTemplate.name,
          subject: this.selectedTemplate.subject
        };
        await EmailTemplateAPIs.saveEmailTemplate(templateId, data);
        this.makeToast({
          content: 'Template Updated',
          header: 'Success!',
          variant: 'success'
        });
      } catch (error) {
        this.$swal({
          type: 'error',
          text: 'Could not save the template'
        });
      }
    },

    async getAllEmailTemplates() {
      try {
        const templates = await EmailTemplateAPIs.getAllEmailTemplates();
        this.templates = Object.assign([], templates);
      } catch (error) {
        console.error(error);
      }
    },

    async getCampaignUsers(campaignID) {
      try {
        let adUsersEmail = [];
        let campaign = await campaignAPIs.getCampaign(campaignID);
        let assignedTo = campaign.assignedTo;
        // console.log('User ID', assignedTo);
        for (let assigner of assignedTo) {
          // console.log('Assigner', assigner)
          const user = await userAPIs.getUser(assigner)

          if (user) {
            adUsersEmail.push(user.email);
          }
        }
        // console.log('Ad USers', adUsersEmail)
        this.fromEmail = adUsersEmail;
      } catch (err) {
        console.log(err)
      }
    },
    /**
     * Check if the influencer's details and deliveriables are correct
     */
    isValidPairing(pairing) {
      // Nyein - changed to valid pairing as default
      return true
      /**
       * - Email cannot be null
       * - Payout amount is mandatory
       * - At least 1 post or 1 story is set
       */
      // return (
      //   pairing.email &&
      //   pairing.payout &&
      //   (pairing.no_of_posts > 0 ||
      //     pairing.no_of_stories > 0 ||
      //     pairing.no_of_carousels > 0 ||
      //     pairing.no_of_video > 0 ||
      //     pairing.no_of_igTv > 0)
      // );
    },

    async getCampaignDetails(campaignID) {
      try {
        const campaign = await campaignAPIs.getCampaign(campaignID);

        this.campaign = Object.assign(
          {},
          {
            campaignId: campaign.id,
            campaignName: campaign.name,
            companyID: campaign.companyID,
            clientID: campaign.clientID,
            campaignOutreach: campaign.outreach,
            campaignEngagement: campaign.engagement,
            campaignBudget: campaign.budget,
            max_content: campaign.max_content,
            min_content: campaign.min_content,
            outreach: campaign.outreach,
            engagement: campaign.engagement,
            budget: campaign.budget
          }
        );
        this.fields = this.fields.concat(utils.func.keyify(this.campaign));
        await this.getClientDetails(campaign.clientID);
        await this.getPairing(campaignID);
      } catch (error) {
        console.log(error)
        this.$swal({
          type: 'error',
          text: 'Could not get campaign details'
        });
      }
    },
    async getClientDetails(clientID) {
      try {
        const client = await clientAPIs.getClient(clientID);
        this.client = Object.assign(
          {},
          {
            clientId: client.id,
            clientName: client.name,
            clientAddress: client.address,
            companyID: client.companyID,
            clientEmail: client.email,
            clientWebsite: client.website,
            clientPhoneNumber: client.phoneNumber
          }
        );
        this.fields = this.fields.concat(utils.func.keyify(this.client));
      } catch (error) {
        console.log(error)
        this.$swal({
          type: 'error',
          text: 'Could not get client details'
        });
      }
    },
    async getPairing(campaignID) {
      try {
        if (!campaignID) {
          return this.$swal({
            type: 'warning',
            text: 'CampaignID cannot be null'
          });
        }
        const pairings = await pairingAPIs.getPairedInfluencersByCampaign(campaignID);
        // Because the API will return all the pairings including rejected influencers
        // Thus we have to filter and also beautify the data in order to adapt the datatable
        // console.log('Parings data', pairings)
        // const items = pairings
        //   .filter(e => e.elimination_details.status === campaignConfig.eliminationStatus.SELECTED)
        //   .map(e => this.beautifyData(e));
        // edited Nyein - to all campaigns
        const items = pairings.map(e => this.beautifyData(e));
        /**
         * #NOTE
         * filter invited influencer list
         */
        const invitedItems = items
        .filter(e => e.pairingStatus !== campaignConfig.pairingStatus.ELIMINATION_PENDING)
        // console.log('🚀 ~ file: CampaignInvite.vue ~ line 808 ~ getPairing ~ invitedItems', invitedItems)
        /**
         * #NOTE
         * filter not invited influencer list
         */
        const notInvitedItems = items
        .filter(e => e.pairingStatus === campaignConfig.pairingStatus.ELIMINATION_PENDING)
        // console.log('🚀 ~ file: CampaignInvite.vue ~ line 792 ~ getPairing ~ invitedItems', notInvitedItems)
        // Get mapable keys to map to email template
        this.fields = this.fields.concat(utils.func.keyify(items[0]));
        this.influencers = Object.assign([], items);
        this.campaignCOEB(items)
        this.campaignCOEBInvited(invitedItems)
        this.campaignCOEBNotInvited(notInvitedItems)
      } catch (error) {
        console.log(error)
        this.$swal({
          type: 'error',
          text: 'Could not get data'
        });
      }
    },
    campaignCOEB(items) {
      this.measurement.total = 0
      this.measurement.outreach = this.measurement.engagement = this.measurement.budget = 0;
      items.map(item => {
        this.measurement.total += Number(this.calculateContents(item))
        this.measurement.outreach += Number(this.calculateOutreach(item));
        this.measurement.engagement += Number(this.calculateEngagement(item));
        this.measurement.budget += Number(item.payout || 0);
      })
      let content = (this.measurement.total / (this.campaign.min_content || this.campaign.min_influencer || 1)) * 100;
      this.measurement.totalPercentage = content > 100 ? 100 : Number(content).toFixed(2);
      this.measurement.outreachPercentage = ((this.measurement.outreach / this.campaign.outreach) * 100).toFixed(2);
      this.measurement.engagementPercentage = ((this.measurement.engagement / this.campaign.engagement) * 100).toFixed(2);
      this.measurement.cogsPercentage = ((this.measurement.budget / this.budget) * 100).toFixed(2);
    },
    campaignCOEBInvited(items) {
      this.measurement.invitedTotal = 0
      items.map(item => {
        this.measurement.invitedTotal += Number(this.calculateContents(item))
        this.measurement.invitedOutreach += Number(this.calculateOutreach(item));
        this.measurement.invitedEngagement += Number(this.calculateEngagement(item));
        this.measurement.invitedBudget += Number(item.payout || 0);
      })
    },
    campaignCOEBNotInvited(items) {
      this.measurement.notInvitedTotal = 0
      items.map(item => {
        this.measurement.notInvitedTotal += Number(this.calculateContents(item))
        this.measurement.notInvitedOutreach += Number(this.calculateOutreach(item));
        this.measurement.notInvitedEngagement += Number(this.calculateEngagement(item));
        this.measurement.notInvitedBudget += Number(item.payout || 0);
      })
    },
    calculateContents(item) {
      return item.no_of_tiktok_posts + item.no_of_reels + item.no_of_posts + item.no_of_video + item.no_of_stories + item.no_of_carousels;
    },
    calculateOutreach(item) {
      const followers = item.followers;
      return followers * (item.no_of_tiktok_posts + item.no_of_reels + item.no_of_posts + item.no_of_video + item.no_of_stories + item.no_of_carousels);
    },
    calculateEngagement(item) {
      const engagement = item.engagement;
      return engagement * (item.no_of_tiktok_posts + item.no_of_reels + item.no_of_posts + item.no_of_video + item.no_of_stories + item.no_of_carousels);
    },
    beautifyData(data) {
      let inf = {};
      const influencerDetails = data.influencer_details;
      const contactDetails = influencerDetails.contact_details || {};
      const deliverablesDetails = data.deliverables_details || {};
      inf.pairingStatus = data.pairing_details.status;
      inf.eliminationStatus = data.elimination_details.status;
      inf.pairingID = data.id;
      inf.influencerID = influencerDetails.influencerID;
      inf.email = contactDetails.email || null;
      inf.phoneNumber = contactDetails.phoneNumber || null;
      inf.no_of_posts = deliverablesDetails.no_of_posts || 0;
      inf.no_of_video = deliverablesDetails.no_of_video || 0;
      inf.no_of_carousels = deliverablesDetails.no_of_carousels || 0;
      inf.no_of_igTv = deliverablesDetails.no_of_igTv || 0;
      inf.followers = influencerDetails.followers || 0;
      inf.engagement = influencerDetails.engagements || 0;
      inf.engagement_rate = influencerDetails.engagement_rate || 0;
      inf.payout = data.payout_details.amount || 0;
      inf.instagramFullname = influencerDetails.fullname;
      inf.no_of_stories = deliverablesDetails.no_of_stories || 0;
      inf.no_of_reels = deliverablesDetails.no_of_reels || 0;
      inf.instagramHandle = influencerDetails.instagramHandle;
      inf.platform = influencerDetails.platform || 'instagram'
      inf.id = data.id;
      inf.emailEdit = false;
      inf.editInfluencer = false;
      return inf;
    },
    openEditItem(item, itemName) {
      item[itemName + 'Edit'] = true
      item.editInfluencer = true
      this.influencers = utils.func.refreshJSON(this.influencers)
      this.disableSaveEdit = false
    },
    editItem(item) {
      this.editedIndex = this.influencers.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialog = true;
    },
    saveEditingData() {
      this.$swal({
        title: 'Double Check!',
        text: 'Make sure you filled all the required information',
        confirmButtonText: 'Confirm',
        type: 'info',
        showCancelButton: true,
        showCloseButton: true
      }).then(result => {
        if (result.value) {
          this.isEditing = true;
          let data = this.influencers.filter(item => item.editInfluencer && item.editInfluencer === true)
          data = data.map(item => {
            return Object.assign({}, {
              id: item.pairingID,
              email: item.email
            })
          })
          // Submit request to save edited pairing data
          pairingAPIs
          .saveEditedCampaignInvite(data)
          .then(response => {
            // Update submitting status
            this.isEditing = false;
            this.cancelEdit()
            // Show success message
            this.$swal({
              text: 'Pairing Updated',
              type: 'success'
            });
          })
          .catch(error => {
            // Update submitting status
            this.isEditing = false;
            // Request failed.
            console.log('error', error);
            this.$swal({
              text: error,
              type: 'error'
            });
          });
        }
      });
    },
    cancelEdit() {
      this.influencers = this.influencers.map(inf => {
        inf.emailEdit = false
        inf.editInfluencer = false
        return inf
      })
      this.disableSaveEdit = true
    },
    preview(item, templateHTML) {
      if (!templateHTML) {
        this.$swal({
          type: 'error',
          text: 'Email template could not be empty'
        });
      }
      const client = Object.assign({}, this.client);
      const campaign = Object.assign({}, this.campaign);
      item = Object.assign(item, Object.assign(client, campaign));
      const html = Mustache.render(templateHTML, item);
      this.previewText = html;
      this.previewDialog = true;
    },

    close() {
      this.dialog = false;
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      }, 300);
    },

    save() {
      if (this.editedIndex > -1) {
        Object.assign(this.influencers[this.editedIndex], this.editedItem);
        const updateData = {
          email: this.editedItem.email,
          no_of_posts: this.editedItem.no_of_posts,
          no_of_stories: this.editedItem.no_of_stories,
          no_of_carousels: this.editedItem.no_of_carousels,
          no_of_video: this.editedItem.no_of_video,
          no_of_igTv: this.editedItem.no_of_igTv
        };
        this.updatePairing(this.editedItem.id, updateData).then(() => {
          console.log('updated');
          return this.$swal({
            type: 'success',
            text: 'Saved!'
          });
        })
      } else {
        this.influencers.push(this.editedItem);
      }
      this.close();
    },
    async updatePairing(pairId, data) {
      try {
        await pairingAPIs.updatePairingDetails(pairId, data);
      } catch (error) {
        console.log(error)
        this.$swal({
          type: 'error',
          text: 'Could not save the pairing details'
        });
      }
    },
    async sendInvitation(pairingId, inviteData, isUpdateStatus) {
      const influencer = this.influencers.find(e => e.id === pairingId);
      try {
        let updated = false
        if (isUpdateStatus) {
          updated = await pairingAPIs.updatePairingStatusOnly(pairingId, inviteData);
        } else {
          updated = await pairingAPIs.inviteInfluencerToCampaign(pairingId, inviteData);
        }
        influencer.isSuccess = true;
        this.sendings.push(influencer);
        // Sending done
        if (this.sendings.length >= this.selectedInfluencers.length) {
          this.isSending = false;
          this.emailDialog = false
          this.getPairing(this.campaign.campaignId);
        }
        return updated;
      } catch (error) {
        influencer.isSuccess = false;
        this.sendings.push(influencer);
        throw error;
      }
    },

    async sendBulkInvitation(selectedInfluencers, templateId) {
      // Must select email template
      if (!templateId) {
        return this.$swal({
          type: 'error',
          text: 'Please select an email template'
        });
      }

      if (this.selectedFromEmail.length === 0) {
        return this.$swal({
          type: 'error',
          text: 'Please select from email'
        });
      }

      let inviteData = {
        templateId,
        fromEmail: this.selectedFromEmail,
        fromEmailName: 'Kobe'
      }

      const influencers = this.influencers.filter(e => selectedInfluencers.find(id => id === e.id));
      let li = '';
      influencers.forEach(inf => {
        li += '<li style=list-style:none !important;>' + `<a target="_blank" href="https://instagram.com/${inf.instagramHandle}">@${inf.instagramHandle}</a>` + '</li>';
      });
      this.$swal({
        title: '<strong>Confirmation</strong>',
        type: 'question',
        showCancelButton: true,
        confirmButtonText: 'Confirm',
        html: 'The following influencers will be invited to this campaign? </br>' + '<ul>' + li + '</ul>'
      }).then(result => {
        if (result.value) {
          this.isSending = true;
          this.sendings = []; // Reset sending list
          this.sendingInvitationDialog = true;
          for (let pairingId of selectedInfluencers) {
            this.sendInvitation(pairingId, inviteData, false);
            // showing the progress
          }
        }
      });
    },
    async updateInvitedStatus(selectedInfluencers) {
      const influencers = this.influencers.filter(e => selectedInfluencers.find(id => id === e.id));
      let li = '';
      influencers.forEach(inf => {
        li += '<li style=list-style:none !important;>' + `<a target="_blank" href="https://instagram.com/${inf.instagramHandle}">@${inf.instagramHandle}</a>` + '</li>';
      });
      this.$swal({
        title: '<strong>Confirmation</strong>',
        type: 'question',
        showCancelButton: true,
        confirmButtonText: 'Confirm',
        html: 'The following influencers will be invited to this campaign? </br>' + '<ul>' + li + '</ul>'
      }).then(result => {
        if (result.value) {
          this.isSending = true;
          this.sendings = []; // Reset sending list
          this.sendingInvitationDialog = true;
          for (let pairingId of selectedInfluencers) {
            let data = {
              pairingStatus: campaignConfig.pairingStatus.INVITED
            };
            this.sendInvitation(pairingId, data, true);
            // showing the progress
          }
        }
      });
    }
  }
};
</script>




// WEBPACK FOOTER //
// CampaignInvite.vue?c152033a